<!-- 窓の表示 -->
<template>
  <section class="window-section">
    <!-- 行番号==最初の窓配置+(窓間隔*回数)) かつ 最後の席でなければ表示 -->
    <div
      v-for="(c, index) in MFITTWindowData.count"
      :key="index"
      class="window-frame"
      :style="[
        props.rowIndex ==
          WindowStartRowNumber + MFITTWindowData.interval * index &&
        props.rowIndex != props.rowNumber
          ? { display: 'block' }
          : '',
      ]"
    />
  </section>
</template>

<script>
import { computed } from "vue";
import MFITTWindowJSON from "@/services/MFITT/windows.json";
import {
  COMMON_SPECIAL_DESIGNATIONS_MAP,
  CAR_SPECIAL_DESIGNATIONS_MAP,
} from "@/lib/constants";

export default {
  name: "MFITTSeatWindow",
  props: {
    // EXE VSEなどの列車型
    trainType: {
      type: String,
      required: true,
    },
    // 号車番号
    carNumber: {
      type: Number,
      required: false,
    },
    // 一般か前後展望か
    specialDesignation: {
      type: String,
      required: false,
    },
    // 親コンポーネントのfor処理の中でのindex
    rowIndex: {
      type: Number,
      required: true,
    },
    // 行番号
    rowNumber: {
      type: Number,
      required: false,
      default: null,
    },
    // 上り下り
    bound: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    // jsonデータから列車型を参照して一般席か前・後展望の窓情報を引き出す
    const MFITTWindowData = computed(() => {
      switch (props.specialDesignation) {
        case COMMON_SPECIAL_DESIGNATIONS_MAP.GENERAL:
        case CAR_SPECIAL_DESIGNATIONS_MAP.A:
        case CAR_SPECIAL_DESIGNATIONS_MAP.B:
        case CAR_SPECIAL_DESIGNATIONS_MAP.C:
        case CAR_SPECIAL_DESIGNATIONS_MAP.D:
        case CAR_SPECIAL_DESIGNATIONS_MAP.E:
        case CAR_SPECIAL_DESIGNATIONS_MAP.F:
        case CAR_SPECIAL_DESIGNATIONS_MAP.G:
        case CAR_SPECIAL_DESIGNATIONS_MAP.H:
        case CAR_SPECIAL_DESIGNATIONS_MAP.I:
        case CAR_SPECIAL_DESIGNATIONS_MAP.J:
          return MFITTWindowJSON[props.trainType].common[props.carNumber];
        case COMMON_SPECIAL_DESIGNATIONS_MAP.FRONT_VIEW:
          return MFITTWindowJSON[props.trainType].foreground[props.carNumber];
        case COMMON_SPECIAL_DESIGNATIONS_MAP.REAR_VIEW:
          return MFITTWindowJSON[props.trainType].background[props.carNumber];
        default:
          return "";
      }
    });

    // 上り下りそれぞれの、窓が最初に配置される行番号を返す
    const WindowStartRowNumber = computed(() => {
      return props.bound == 1
        ? MFITTWindowData.value.start.bound1
        : MFITTWindowData.value.start.bound0;
    });

    return {
      props,
      MFITTWindowData,
      WindowStartRowNumber,
    };
  },
};
</script>

<style lang="scss" scoped>
.window-section {
  width: 100%;
  position: absolute;
}

.window-frame {
  position: absolute;
  border-right: 8px solid #bfa482;
  border-left: 8px solid #bfa482;
  width: calc(100% - 4px);
  height: 24px;
  padding: 0;
  margin-left: -14px;
  width: calc(100% - 4px) !important;
  margin-top: 30px;
  display: none;
}
</style>
